export default "__VITE_ASSET__DYkdY6PH__"